export default {
  messages: state => state.messages
}



// WEBPACK FOOTER //
// ./src/store/modules/message/getters.js